import FqApi from '@/services/fq-api'

export default {
  async getInsurerSummaries(ecomType, name, pageIndex, pageSize) {
    if ((ecomType === 'audanet')) {
      const url = `/insurers/loadtask/insurerlist?name=${name}`
      const result = await FqApi.get(url)
      return result.data
    } else {
      const url = 'insurers/insurerlookup'
      const result = await FqApi.post(url, { Name: name, EcomType: ecomType, PageIndex: pageIndex, PageSize: pageSize })
      return result.data
    }
  },
  async getQuoteIdByNo(quoteNo) {
    const result = await FqApi.get(`quotes/quoteidbyno?quoteNo=${quoteNo}`)
    return result.data
  },
  async assertCustomerExists(name) {
    const url = `/ormmessages/load/customerexists?name=${encodeURIComponent(name)}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getCustomerSummaries(fullname) {
    const url = `/customers/loadquote/customerlist?fullname=${fullname}`
    const result = await FqApi.get(url)
    return result.data
  },
  async getQuoteSummaries(rego, claimno, isrepx) {
    if (isrepx == undefined || isrepx == null) isrepx = false
    const params = []
    if (rego && rego.trim() !== '') {
      params.push(`rego=${encodeURIComponent(rego.trim())}`)
    }
    if (typeof isrepx !== 'undefined') {
      params.push(`isrepx=${isrepx}`)
    }
    if (claimno && claimno.trim() !== '') {
      params.push(`claimno=${encodeURIComponent(claimno.trim())}`)
    }
    const url = `/quotes/assignquotesummaries${params.length ? '?' + params.join('&') : ''}`
    const result = await FqApi.get(url)
    return result.data
  }
}
